import { render, staticRenderFns } from "./TournamentEventDrawEdit.vue?vue&type=template&id=076025c8&scoped=true&"
import script from "./TournamentEventDrawEdit.vue?vue&type=script&lang=js&"
export * from "./TournamentEventDrawEdit.vue?vue&type=script&lang=js&"
import style0 from "./TournamentEventDrawEdit.vue?vue&type=style&index=0&id=076025c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076025c8",
  null
  
)

component.options.__file = "TournamentEventDrawEdit.vue"
export default component.exports